import { useQuery } from '@tanstack/react-query'
import { API_V1 } from '../config'
import { apiFetch } from '../services/api'

export interface ActivityEntry {
  id: number
  category: 'signing' | 'document' | 'system'
  action: string
  action_display: string
  description: string
  performed_by_name: string | null
  performed_by_system: boolean
  signer_email: string | null
  signer_name: string | null
  details: Record<string, unknown>
  created_at: string
}

export interface ActivityResponse {
  activities: ActivityEntry[]
  count: number
  total_count: number
}

async function getActivity(koblinkId: string, actorId?: string, limit = 20): Promise<ActivityResponse> {
  const params = new URLSearchParams({ limit: String(limit) })
  if (actorId) params.set('actor_id', actorId)
  const response = await apiFetch(
    `${API_V1}/documents/${encodeURIComponent(koblinkId)}/activity/?${params}`,
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch activity: ${response.status}`)
  }
  return response.json()
}

/**
 * Fetch activity log for a document.
 * Note: Only available for organization-owned documents.
 */
export function useActivity(koblinkId: string | undefined, actorId?: string, enabled = true) {
  return useQuery<ActivityResponse>({
    queryKey: ['activity', koblinkId, actorId],
    queryFn: () => getActivity(koblinkId!, actorId),
    enabled: !!koblinkId && enabled,
    staleTime: 30_000,
  })
}
